module.exports = __webpack_public_path__ + "img/form-background-blur.7d37892a.svg";